import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/pages/404/404.png")